import axiosPrivate from "@services/axiosPrivate"
import { GET_PATIENT } from "src/constants"

export const getPatient = (paginationState) => {
  return axiosPrivate.get(GET_PATIENT, {
    params: {
      ...paginationState,
    },
  })
}
